export enum CURRENT_SEL {
    TERM = "currentTerm",
    COURSE = "currentCourse"
}
